import { AutoAwesomeRounded, BusinessRounded, LoginRounded } from '@mui/icons-material';
import { Alert, Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { useAccessInfo } from '../contexts/AccessTokenProvider';
import useViewportMode from '../hooks/useViewportMode';
import { useLocation } from 'react-router-dom';

const StartOrganizationPage = () => {
    const { startOnboarding } = useAccessInfo();
    const location = useLocation();
    const { mode, isPhone } = useViewportMode();

    return (
        <Container maxWidth="sm" data-viewport-mode={mode} sx={{ py: { xs: 3, sm: 8 }, px: { xs: 2, sm: 3 } }}>
            <Paper variant="outlined" sx={{ p: { xs: 2.5, sm: 4 }, borderRadius: 3 }}>
                <Stack spacing={2.5} alignItems="flex-start">
                    <BusinessRounded color="primary" sx={{ fontSize: 44 }} />
                    <Box>
                        <Typography component="h1" variant={isPhone ? 'h4' : 'h3'} fontWeight={800}>
                            Start your organization
                        </Typography>
                        <Typography color="text.secondary" sx={{ mt: 1 }}>
                            Sign in first, then we’ll guide you through company context, your first position, what success looks like, and the people you’re developing.
                        </Typography>
                    </Box>
                    <Alert icon={<AutoAwesomeRounded />} severity="info">
                        Microsoft is the fastest option. Email sign-in is also available. Synergist never collects your password in this setup flow.
                    </Alert>
                    {new URLSearchParams(location.search).get('auth') === 'cancelled' && <Alert severity="warning">Secure sign-in was canceled safely. Nothing changed. Continue when you’re ready.</Alert>}
                    <Button
                        fullWidth
                        size="large"
                        variant="contained"
                        startIcon={<LoginRounded />}
                        onClick={startOnboarding}
                        sx={{ minHeight: 52 }}
                    >
                        Continue to secure sign in
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
};

export default StartOrganizationPage;
